<template>
  <div class="im-card-message" :class="{ right: isMe }" @click="onTap">
    <div class="content-list">
      <div class="content-item">
        <div class="subtitle-head">
          <!-- <div v-if="item.title" class="subtitle">
            <span>{{ item.title }}</span>
          </div> -->
          <div class="subtitle-h3">
            <span class="h3">诊疗</span>
            <span v-if="messageContext.count" class="intro">
              共{{ messageContext.count }}项申请
            </span>
          </div>
        </div>
        <div v-if="messageContext.treatmentDetailList.length" class="content">
          <div
            v-for="(txt, i) in messageContext.treatmentDetailList.slice(0, 2)"
            :key="i"
            class="txt"
          >
            <span class="text"> {{ txt.itemName }}{{ txt.amount }}{{ txt.itemUnix }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { diagnosisCb } from '../../utils/timInit'
export default {
  name: 'imCustomInspect',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // messageContext: {
      //   id: 13692,
      //   prescripOrderType: '2',
      //   treatmentDetailList: [
      //     {
      //       id: '',
      //       hospitalID: '26373',
      //       hospitalName: '内蒙古自治区国际蒙医医院',
      //       itemName: '肝功七项（门诊）',
      //       itemType: '2',
      //       itemIDfromHis: '14760=00551066',
      //       lisID: null,
      //       sampleType: 'A1',
      //       checkMethod: null,
      //       itemClass: '14760',
      //       superItemClass: null,
      //       bodyPart: '',
      //       applicationFormName: null,
      //       forbidSex: null,
      //       medicalInsuranceType: null,
      //       price: 51,
      //       itemUnix: '项',
      //       pinyinCode: 'GGQX（MZ）',
      //       state: '1',
      //       desc: null,
      //       remark: null,
      //       dataFrom: '2',
      //       isValid: null,
      //       createTime: '2021-11-29 09:29:37',
      //       updateTime: '2022-03-11 01:32:11',
      //       exeDept: [{ deptName: '临床检验中心', deptCode: '4038' }],
      //       drugFlag: 1646956586239,
      //       amount: '1',
      //       exeDeptID: '4038',
      //       exeDeptName: '临床检验中心',
      //       detailDesc: '',
      //       prescripOrderType: '2'
      //     }
      //   ],
      //   prescripSort: '1',
      //   amount: 6,
      //   feeType: '7',
      //   prescriporderNo: ''
      // }
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    }
  },
  methods: {
    onTap() {
      typeof diagnosisCb === 'function' && diagnosisCb(this.message)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-card-message {
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
  background: #ffffff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .title-wrap {
      border-radius: 0.597333rem 0 0 0;
    }
  }

  .title-wrap {
    padding: 0.384rem 0.512rem;
    font-size: 0.64rem;
    line-height: 0.853333rem;
    color: #ffffff;
    background: #0089ff;
    border-radius: 0 0.597333rem 0 0;

    & > .text {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .content-list {
    padding: 0.256rem 0.512rem;

    .content-item {
      position: relative;

      .subtitle-head {
        border-bottom: 0.021333rem solid #ececec;
      }

      .subtitle {
        display: flex;
        align-items: center;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        padding-left: 0.213333rem;
        color: #222222;
        font-weight: 500;
        overflow: hidden;

        &::before {
          content: '';
          margin-right: 0.213333rem;
          display: block;
          width: 0.085333rem;
          height: 0.469333rem;
          border-radius: 0.053333rem;
          background: #0089ff;
        }

        & > .text {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .subtitle-h3 {
        padding-top: 0.597333rem;
        padding-bottom: 0.512rem;
        display: flex;
        align-items: center;
        overflow: hidden;

        .h3 {
          margin-right: 0.32rem;
          display: block;
          flex: 1;
          font-size: 0.64rem;
          line-height: 0.64rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: left;
        }

        .intro {
          flex: 2;
          font-size: 0.597333rem;
          line-height: 0.64rem;
          color: #888888;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: right;
        }
      }

      .content {
        padding-top: 0.256rem;
        font-size: 0.64rem;
        line-height: 0.938667rem;
        color: #222222;

        .txt {
          padding-top: 0.256rem;
          padding-left: 0.298667rem;
          padding-bottom: 0.256rem;
          text-align: left;
          & > .text {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
          }
        }
      }
    }
  }
}
</style>
